import React, { useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { getTable, getTableIDsSorted, getPlayer, roomSlice } from './roomSlice';
import { getGameType, getBoardType } from '../settings/settingsSlice';
import { getCanJoinGame } from '../view/viewSlice';
import { useDispatch } from 'react-redux';
import classNames from "classnames";
import { GameTypeNormal, GameTypeFast, GameTypeStress, GameTypeRush, GameTypePanic, GameTypeUnlimited, BoardTypeClassic, BoardTypeSpecial, BoardTypeRandom, Ranked } from './Icon';
import { useTranslation } from 'react-i18next';

import './TableList.css';
import { Button } from '../../components/Button';

const GameTypeIcon = React.memo((props) => {
  switch (props.gametype) {
    case 0:
      return <GameTypeNormal />;
    case 1:
      return <GameTypeFast />;
    case 2:
      return <GameTypeStress />;
    case 3:
      return <GameTypeRush />;
    case 4:
      return <GameTypePanic />;
    case 5:
      return <GameTypeUnlimited />;
    default:
      throw Error('Unknown gametype: '+props.gametype);
  }
});

const BoardTypeIcon = React.memo((props) => {
  switch (props.boardtype) {
    case 0:
      return <BoardTypeRandom />;
    case 1:
      return <BoardTypeClassic />;
    case 2:
      return <BoardTypeSpecial />;
    default:
      throw Error('Unknown boardtype: '+props.boardtype);
  }
});

const TableListPlayerItem = (props) => {
  const player = useSelector(state => getPlayer(state, props.id), shallowEqual);

  return (
    <div>{player.name}<span className="rating">{player.rating}</span></div>
  )
}

const TableListItem = (props) => {
  const { t } = useTranslation();
  const table = useSelector(state => getTable(state, props.id), shallowEqual);
  const gameType = useSelector(state => getGameType(state, table.gametype), shallowEqual);
  const boardType = useSelector(state => getBoardType(state, table.boardtype), shallowEqual);
  const canJoinGame = useSelector(getCanJoinGame);
  const dispatch = useDispatch();

  const [showPlayers, setShowPlayers] = useState(false);

  let button = null;
  if (table.started) {
    button = <Button onClick={(e) => dispatch({ type: 'action/spy', payload: { id: table.id }})} disabled={!canJoinGame}>{t('WATCH')}</Button>;
  } else {
    button = <Button onClick={(e) => dispatch({ type: 'action/join', payload: { id: table.id }})} disabled={!canJoinGame || table.players.length >= table.numplayers}>{t('JOIN')}</Button>;
  }

  const playersElem = (() => {
    if (!showPlayers) {
      return null;
    }

    const players = table.players.map((id) => {
      return <TableListPlayerItem key={id} id={id} />;
    });

    return (
      <tr>
        <td></td>
        <td colSpan="7">
          <div className="players">
            {players}
          </div>
        </td>
      </tr>
    )
  })();


  const tbodyCls = classNames({
    blink: !table.started && table.invited,
  });
  const trCls = classNames({
    playing: table.started,
  });
  return (
    <tbody className={tbodyCls} onAnimationEnd={e => dispatch(roomSlice.actions.updateTable({id: props.id, invited: false}))} onClick={e => { setShowPlayers(!showPlayers); e.preventDefault(); }}>
      <tr className={trCls}>
        <td className="icon"><Ranked ranked={table.rank}/></td>
        <td>{table.name}</td>
        <td className="icon"><BoardTypeIcon boardtype={table.boardtype}/></td>
        <td className="small">{boardType.name}</td>
        <td className="icon"><GameTypeIcon gametype={table.gametype}/></td>
        <td className="small">{gameType.shortName}</td>
        <td>{table.players.length}/{table.numplayers}</td>
        <td className="button">{button}</td>
      </tr>
      {playersElem}
    </tbody>
  );
}

export const TableListNew = () => {
  const { t } = useTranslation();
  const canJoinGame = useSelector(getCanJoinGame);

  const dispatch = useDispatch();

  const tableIDs = useSelector(getTableIDsSorted(false), shallowEqual);
  if (tableIDs.length === 0) {
    return (
      <>
        <h2>{t("NEW_GAMES")}</h2>
        <div className="noTables box">
          <div>Inga nya spel.</div>
          <div><Button onClick={(e) => dispatch({ type: 'action/precreate' })} disabled={!canJoinGame}>{t('CREATE_NEW')}</Button></div>
        </div>
      </>
    );
  }

  const tables = tableIDs.map((id) => {
    return <TableListItem key={id} id={id}/>;
  });

  return (
    <>
      <div><h2>{t("NEW_GAMES")}</h2></div>
      <div className="tableList box"><table>{tables}</table></div>
      <div className="buttonRow"><Button onClick={(e) => dispatch({ type: 'action/precreate' })} disabled={!canJoinGame}>{t('CREATE_NEW')}</Button></div>
    </>
  );
}

export const TableListStarted = () => {
  const { t } = useTranslation();
  const tableIDs = useSelector(getTableIDsSorted(true), shallowEqual);

  if (tableIDs.length === 0) {
    return null;
  }

  const tables = tableIDs.map((id) => {
    return <TableListItem key={id} id={id}/>;
  });

  return (
    <>
      <h2>{t("STARTED_GAMES")}</h2>
      <div className="tableListWrapper"><div className="tableList box"><table>{tables}</table></div></div>
    </>
  );
}
